import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import request from '../../Apis/request';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { QRCode } from 'qrcode.react';
import { Link } from 'react-router-dom';
import Loader from '../Chargers/Loader';
import ReactPaginate from 'react-paginate'; 
import Select from 'react-select';

const KWPowerDifference = () => {
  document.title = "Evtor || KW Power Difference";
  const [OCPPData, setOCPPData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [ChargerData, setChargerData] = useState([]);
  const [selectedchargerEmi, setSelectedChargerEmi] = useState('');
  const [selectedLimit, setSelectedLimit] = useState("");
  const [selectedchargerID, setSelectedChargerID] = useState('');
  const [fromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [applyFilters, setApplyFilters] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [Limit, setLimit] = useState();
  const [page, setPage] = useState(1); 
  const [pageCount, setPageCount] = useState(0); 
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  const chargerOptions = ChargerData?.map((item) => ({
    value: `${item?.imei_number}@${item?._id}`, // Value combines IMEI and ID
    label: item?.imei_number, // Display the IMEI number
  }));
  let navigate = useNavigate();
const handlefromDate = (e) => {
    setFromDate(e.target.value);
  }
  const handleToDate = (e) => {
    setToDate(e.target.value);
  }
const handleFetchingChange = () => {
    fetchOcppData();
  };
const fetchChargers = async () => {
    setLoading(true);
    const apiEndpoint = `${BaseURL}/chargers/?master_charger_type=evtor-0`;

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      setChargerData(response.data.data.data || []);
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChargers();
  }, []);

  const fetchOcppData = async (applyFilters = false,  fromDate = null, toDate = null) => {
    setLoadings(true);
    
    const queryParams = [];
  
    // Case 2: Add `chargerEmi` filter if selected
    if (selectedchargerEmi) {
      queryParams.push(`imei_number=${selectedchargerEmi}`);
    }
   if (applyFilters) {
   
    // Case 3: Add `MessageType`, `fromDate`, and `ToDate` filters if `applyFilters` is true
    if ( fromDate ) {
      queryParams.push(`from_date=${fromDate.toString()} 00:00:00`);
    }
     
    if( toDate ) {
      queryParams.push(`to_date=${toDate.toString()} 23:23:23`);
      }
  
  }
    const queryString = queryParams.length > 0 ? `&${queryParams.join('&')}` : '';
  
    try {
      const apiEndpoint = `${BaseURL}/evtorLog/power-error/?page=${page}${queryString}`;
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      console.log('Fetched data:', response?.data);
      setOCPPData(response?.data?.data || []);
      setTotalCount(response?.data?.totalCount);
      setPageCount(Math.ceil(response?.data?.totalCount / response?.data?.limit || 0)); 
      setLimit(response?.data?.limit || 0)

    } catch (error) {
      console.error("Error fetching OCPP data:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Handle filter button click (Case 3)
  const handleFilterClick = () => {
    setPage(1);
    // Trigger fetch with `applyFilters` set to true and pass the MessageType, fromDate, and ToDate
    if ( fromDate || ToDate) {
      fetchOcppData(true, fromDate, ToDate );
    } else {
    fetchOcppData(); 
    }
  };
  
  useEffect(() => {
    fetchOcppData(page);
  }, [selectedchargerEmi, page]); // Trigger whenever `selectedchargerEmi` changes

const handleChargerEmiChange = (selectedOption) => {
  if (selectedOption) {
    const [imei, id] = selectedOption?.value.split("@");
    console.log("Selected IMEI and ID:", imei, id);
    setSelectedChargerEmi(imei);
    setSelectedChargerID(id);
  } else {
    setSelectedChargerEmi(null);
    setSelectedChargerID(null);
  }
};

const handleResett = (event) => {
  event.preventDefault()
 navigate(`/evtor-logs/kwpowerdifference`);
  }

 console.log("OCPPData", OCPPData);
 console.log("totalcount", totalCount);
 console.log("pagecountttttttt", pageCount);
 console.log("Limit", Limit);

  return (
    <div className='container-fluid' style={{ minHeight: '100vh', padding: '0px', margin: '0px' }}>
      <div className='row' style={{ height: '100%' }}>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
              <div className="d-flex justify-content-between align-items-center">
                <h4>Charger Consumption Data({totalCount  ? totalCount : "Loading..."})</h4>
              </div>
              <div className="card-header pb-0">
  <div className="d-flex justify-content-between mb-2"> {/* Changed justify-content */}
    <div className="button-group d-flex gap-2" style={{ top: "20px" }}>
      <div style={{ display: "inline-flex", alignItems: "center" , marginRight: '10px' }}>
      <Select
  options={chargerOptions} // Pass the options array
  onChange={handleChargerEmiChange} // Handle selection
  placeholder="Select Charger"
  isClearable // Allow clearing the selection
  
  styles={{
    control: (base) => ({
      ...base,
      height: '34px',
      width: '250px',
      marginRight: '10px',
    }),
  }}
/>

        <input
  type="text"
  className="form-control select2 select2-offscreen"
  onFocus={(e) => (e.target.type = "date")}
  onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
  placeholder="From Date"
  onChange={handlefromDate}
  style={{ height: '34px', marginRight: '10px' }} // Adjusted for consistency
/>

<input
  type="text"
  className="form-control select2 select2-offscreen"
  onFocus={(e) => (e.target.type = "date")}
  onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
  placeholder="To Date"
  onChange={handleToDate}
  style={{ height: '34px', marginRight: '10px' }} // Adjusted for consistency
/>


        <input
          type="button"
          className="btn btn-success"
          style={{ marginRight: '10px', height: '34px' }} // Adjusted height for consistency
          value="Filter"
          onClick={handleFilterClick}
        />
           <button
          className="btn btn-success"
          style={{ marginRight: '10px', height: '34px' }} // Adjusted height for consistency
          onClick={handleResett}
        >Reset
          </button>
         </div>
    </div>
  </div>
  <hr style={{ marginTop: "0px" }} />
</div>



      

              <div className="row" style={{ display: 'flex', alignItems: 'flex-start' }}>
               <div>
                <div className="card-body" style={{ paddingTop: 0 }}>
  {loadings ? (
    <Loader />
  ) : (
    <>
    <div className="table-responsive" style={{ marginTop: '10px' }}>
      {totalCount === 0 ? ( // Only show "No Data Found" when there's no data and loading is done
        <h6 className="text-center">No Data Found</h6>
      ) : (
                 
        <table className="display dataTable" id="advance-1">
        <thead>
          <tr>
          
              <th>Sr. No</th>
              <th>Charger EMI</th>
              <th>Charger Request Data</th>
              <th>Old Power</th>
              <th>Current Power</th>
              <th>Power Difference</th>
              <th>Created Date</th>
      
          </tr>
        </thead>
        <tbody>
  {OCPPData?.length === 0 ? (
    <tr>
      <td colSpan="8" className="text-center"><Loader /></td>
    </tr>
  ) : (
    OCPPData
      // ?.filter((ocpp) => parseFloat(ocpp?.old_power) !== 0 && parseFloat(ocpp?.current_power) !== 0) // Filter out rows where old power is 0
      .map((ocpp, index) => (
        <tr key={index}>
          <td>{(page - 1) * Limit + index + 1}</td>
          <td>{ocpp?.request[0]?.IMEI}</td>
          <td>
            <span style={{ color: 'red' }}>V|{ocpp?.request[0]?.V}</span>{' '}
            <span style={{ color: 'blue' }}>I|{ocpp?.request[0]?.I}</span>{' '}
            <span style={{ color: 'green' }}>P|{ocpp?.request[0]?.P}</span>{' '}
            <span style={{ color: 'purple' }}>B|{ocpp?.request[0]?.B}</span>
          </td>
          <td>{ocpp?.old_power}</td>
          <td>{ocpp?.current_power}</td>
          <td>{ocpp?.power_diff}</td>
          
          <td>{ocpp?.createdAt}</td>
        </tr>
      ))
  )}
</tbody>

      </table>
      )}
    
    </div>
    <div className="pagination-container mt-4">
<ReactPaginate
  previousLabel={'Previous'}
  nextLabel={'Next'}
  breakLabel={'...'}
  pageCount={pageCount}
  marginPagesDisplayed={2}
  pageRangeDisplayed={5}
  onPageChange={handlePageClick}
  containerClassName={'pagination'}
  subContainerClassName={'pages pagination'}
  activeClassName={'active'}
  forcePage={page - 1} 
/>
</div>
    </>
  )}
</div>
</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
  </div>
  );
};

export default KWPowerDifference;